export const GetModeTypesActions= {
	
	GetModeTypes_GET :{
		NEW:"GetModeTypes_GET_NEW",
		SUCCESS:"GetModeTypes_GET_SUCCESS",
		FAILED:"GetModeTypes_GET_FALIURE",
		LOADING:"GetModeTypes_GET_LOADING",
		UPDATE:"DisableGetModeTypes_Update_SUCCESS",
	},
	
}


export const GetModeTypesStatus ={

	GetModeTypes_GET :{
		NEW:"GetModeTypes_GET_NEW",
		SUCCESS:"GetModeTypes_GET_SUCCESS",
		FAILED:"GetModeTypes_GET_FALIURE",
		LOADING:"GetModeTypes_GET_LOADING",
	}

}
